import { jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_Workspace, TS_HorizontalWorkspace, TS_Workspace } from '@nu-art/ts-workspace-frontend/index';
import { ComponentSync, TS_ErrorBoundary } from '@nu-art/thunderstorm-frontend/index';
import './Panel_ResourceManager.scss';
import { ModuleFE_Resource } from '@app/hcs-frontend';
import { ModulePackFE_Organization } from '@app/org-frontend';
import { PanelWrapper_ResourceManager } from './PanelWrapper_ResourceManager.js';
import { EditorWrapper_Resources } from '../editors/EditorWrapper_Resources.js';
export class Panel_ResourceManager_V1_old extends ComponentSync {
    static Route = {
        key: 'resource-manager',
        path: 'resource-manager',
        Component: this,
        enabled: () => false,
        modulesToAwait: [...ModulePackFE_Organization, ModuleFE_Resource]
    };
    key = 'search';
    renderers = {
        horizontalSpace: TS_HorizontalWorkspace,
        searchPanel: PanelWrapper_ResourceManager,
        dataViewer: EditorWrapper_Resources
    };
    render() {
        return (_jsx(TS_ErrorBoundary, { onClick: async (e) => {
                await ModuleFE_Workspace.deleteWorkspaceByKey(this.key);
                this.forceUpdate();
            }, children: _jsx(TS_Workspace, { workspaceKey: this.key, renderers: this.renderers }) }));
    }
}
